import useClientState from '@/state/useClientState';

const useScrollStore = () => {
  const scale = useClientState((state) => state.mwd.scale);
  const miniMwdScale = useClientState((state) => state.miniMwd.scale);
  const scrollX = useClientState((state) => state.scrollX);
  const scrollY = useClientState((state) => state.scrollY);
  const scrollBehavior = useClientState((state) => state.scrollBehavior);
  const scrollLeft = useClientState((state) => state.scrollLeft);
  const scrollTop = useClientState((state) => state.scrollTop);
  const offsetWidth = useClientState((state) => state.offsetWidth);

  return {
    scrollX,
    scrollY,
    scrollBehavior,
    scrollLeft,
    scrollTop,
    offsetWidth,
    scale,
    miniMwdScale,
  };
};

export default useScrollStore;
